export function normalizeTenantSettings(responseData = {}) {
  const {
    company_name = "",
    domain = "",
    ldap_host = "",
    ldap_port = "",
    ldap_user = "",
    ldap_base_dn = "",
    daily_worklog_hours = 0,
    daily_worklog_reminder = false,
    google_login_enabled = false,
    google_workspace_domain = "",
    planner_token_sharing_enabled = false,
    rocketchat_shared_secret = "",
    slack_bot_token = "",
  } = responseData || {};

  return {
    companyInfo: {
      company_name,
      domain: domain.split(".")?.[0] || "",
    },
    workingHours: {
      daily_worklog_reminder,
      daily_worklog_hours,
    },
    plannerSettings: {
      planner_token_sharing_enabled,
    },
    googleAuth: {
      google_login_enabled,
      google_workspace_domain,
    },
    ldapSettings: {
      ldap_url: ldap_host && ldap_port ? `${ldap_host}:${ldap_port}` : "",
      ldap_user,
      ldap_base_dn,
    },
    integrations: {
      rocketchat_shared_secret,
      slack_bot_token,
    },
  };
}

export function hasSettingsChanges(values = {}, initialData = {}) {
  return Object.keys(values).some((key) => {
    const value = values[key];
    const initialValue = initialData[key];

    return value !== undefined && value !== "" && value !== null && value !== initialValue;
  });
}

export function validateTenantDomain(domain, initialDomain) {
  if (/\s/.test(domain)) {
    return "Domain must not contain spaces.";
  }

  if (!/^[a-zA-Z0-9-]+$/.test(domain)) {
    return "Domain must not contain special characters.";
  }

  if (!domain || domain === initialDomain) {
    return null;
  }

  return null;
}

export function buildCompanyInfoPayload(formData, initialDomain) {
  if (initialDomain === formData.domain) {
    return {
      company_name: formData.company_name,
    };
  }

  return formData;
}

export function buildLdapPayload(formData, parseLdapUrl) {
  const { host = "", port = "" } = formData.ldap_url
    ? parseLdapUrl(formData.ldap_url)
    : {};

  return {
    ldap_host: host || null,
    ldap_port: port || null,
    ldap_base_dn: formData.ldap_base_dn || null,
    ldap_user: formData.ldap_user || null,
    ldap_password: formData.ldap_password || null,
  };
}

export function shouldResetPlannerTokens(enabled) {
  return enabled === true;
}
